module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_14.e6656953.pdf";